namespace Matrix.Indexation {
    export interface FactCompositeConstituentForm {
        IndexationProfileKey: Serenity.IntegerEditor;
        CompositeIndexKey: Serenity.IntegerEditor;
        ConstituentIndexKey: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        HedgeRatio: Serenity.DecimalEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FactCompositeConstituentForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.FactCompositeConstituent';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FactCompositeConstituentForm.init)  {
                FactCompositeConstituentForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(FactCompositeConstituentForm, [
                    'IndexationProfileKey', w0,
                    'CompositeIndexKey', w0,
                    'ConstituentIndexKey', w0,
                    'Weight', w1,
                    'HedgeRatio', w1,
                    'DefaultSortOrder', w0,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
